export default __webpack_public_path__ + "static/media/mini_vajra.5a75fdca.png";